/**
 * -------------------------------------
 * Action Types definition
 * -------------------------------------
 * */
import { IWorkstationInfoModel } from "../../interfaces/Login/IWorkstationInfoModel";
import { IOperatorInfoModel } from "../../interfaces/Login/IOperatorInfoModel";
import {
  SET_USER,
  SET_WORKSTATION,
  LoginState,
  LoginStateTypes,
  CLEAR_LOGIN_STATE,
  SET_IS_PARTIAL_DELIVERY_ENABLED,
} from "../types/LoginStateTypes";
import { IPayloadWrapper } from "../types/PayloadWrapper";

/**
 * -------------------------------------
 * Action Creator definitions
 * -------------------------------------
 * */
export const setUser = (payload: IOperatorInfoModel): LoginStateTypes => {
  return {
    type: SET_USER,
    payload,
  };
};

export const setWorkstation = (payload: IWorkstationInfoModel): LoginStateTypes => {
  return {
    type: SET_WORKSTATION,
    payload,
  };
};

export const clearLoginState = (): LoginStateTypes => {
  return {
    type: CLEAR_LOGIN_STATE,
  };
};

const initialLoginState: LoginState = {
  operatorID: -1,
  operatorName: "Okänd",
  workstationID: -1,
  workstationType: 0,
  autoScaleEnabled: false,
  branchID: -1,
  partialDeliveryAccess: false,
  companyID: -1,
};

/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const loginInfoReducer = (state = initialLoginState, action: LoginStateTypes): LoginState => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        ...action.payload,
      };
    case SET_WORKSTATION:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_LOGIN_STATE:
      return {
        ...state,
        ...initialLoginState,
        workstationID: state.workstationID,
        workstationType: state.workstationType,
      };
    default:
      return state;
  }
};

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export default loginInfoReducer;
